import {FaceHeartCreditsResponse} from '../models'
import {assertNumber, assertObjectOrUndefined, assertString} from '../utils'
import {AssertTypeFn} from './general'

const faceHeartSdkConfigNormaliser: AssertTypeFn<
  NonNullable<FaceHeartCreditsResponse['sdkConfig']>
> = (obj) => ({
  license: assertString(obj.license),
  host: assertString(obj.host),
  port: assertNumber(obj.port),
})

export const faceHeartCreditsNormaliser: AssertTypeFn<
  FaceHeartCreditsResponse
> = (obj) => ({
  availableCredits: assertNumber(obj.availableCredits),
  sdkConfig: assertObjectOrUndefined(
    obj.sdkConfig,
    faceHeartSdkConfigNormaliser,
  ),
})
